import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import classNames from 'classnames';
import { useVerticalStepperContext } from '../VerticalStepper.Context/VerticalStepper.Context.es.js';

const VerticalStepperStepWrapper = ({ isDisabled = false, variant = 'default', onClick, children })=>{
    const { isFlowComplete = false, isInteractive = true } = useVerticalStepperContext();
    const handleClick = useCallback((event)=>{
        event.preventDefault();
        if (!isDisabled && !isFlowComplete) {
            onClick?.();
        }
    }, [
        isDisabled,
        isFlowComplete,
        onClick
    ]);
    if (!isInteractive) {
        return jsx("span", {
            className: classNames('cb-vertical-stepper-step-wrapper'),
            children: children
        });
    }
    return jsx("button", {
        className: classNames('cb-vertical-stepper-step-wrapper', {
            disabled: isDisabled || isFlowComplete,
            warning: variant === 'warning',
            success: variant === 'success'
        }),
        onClick: handleClick,
        children: children
    });
};
VerticalStepperStepWrapper.displayName = 'VerticalStepper.StepWrapper';

export { VerticalStepperStepWrapper };
//# sourceMappingURL=VerticalStepper.StepWrapper.es.js.map
